import canUseDOM from '../utils/canUseDOM'

const Hammer = canUseDOM && require('hammerjs')

export const swipe = {
  bind: function(el, binding) {
    if (typeof binding.value === "function") {
      const mc = new Hammer(el, {
        touchAction: 'pan-y'
      })
      mc.get('pan').set({
        direction: Hammer.DIRECTION_ALL,
      });
      mc.on("panend panleft panright panup pandown", binding.value)
    }
  }
}
